<template>
  <modal
      name="change-payment-info-modal"
      :width="450"
      :height="`auto`"
      :pivotX="0.5"
      :pivotY="0.5"
      :delay="100"
      @before-open="beforeOpen"
  >
    <div class="FloatMenu md_overlay md_overlay_0 ">
      <div class="modal modal_0">
        <div class="md_content md_type2">
          <div class="popup_title">
            {{ $t('my.payment.serviceInfo.changing_payment')}}
          </div>
          <span class="md_close">
            <img
                @click="modalClose"
                src="/images/union.svg"
                alt=""
            />
          </span>
          <div class="title_desc">You can change it once a month.</div>
          <div class="payment_contents_container mt30 mb40 txt_body_1 --grey100">
            <span>{{ currentSubscriptionInfoProps.defaultProductSubTitle }}</span>
            <span class="txt_divider">|</span>
            <span class="txt_subtitle_1">Pay &nbsp;</span> 60 USD / {{ computedPaymentType(currentSubscriptionInfoProps.paymentType) }}
          </div>
          <LoadingOverlay
              :activeSyncProps="activeSync"
              :isFullPageProps="false"
          />
          <PaymentInput
              ref="paymentInput"
              class="change_payment_detail"
          />
          <a
              class="btn blue btn_basics"
              @click="updatePayment"
          >
            {{ $t('status.confirm') }}
          </a>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import _API from '@/api';
import LoadingOverlay from "../../loadingOverlay";
import PaymentInput from "@/components/body/payments/info/inputArea";
import validationMethods from '@/common/lib/validation.js';
import encrypt from "@/common/lib/encrypt";

export default {
  name: 'ChangePaymentInfoModal',
  data() {
    return {
      activeSync: false,
      currentSubscriptionInfoProps: {},
      paymentInfoProps: {}
    }
  },
  components: {
    LoadingOverlay,
    PaymentInput
  },
  computed: {
    computedPaymentType() {
      return (paymentType) => {
        let type = '';
        switch (paymentType) {
          case 2:
            type = 'Monthly';
            break;
          case 3:
            type = 'Yearly';
            break;
          default:
            type = 'Error'
            break;
        }
        return type
      }
    }
  },
  methods: {
    ...encrypt,
    ...validationMethods,
    modalClose() {
      this.$modal.hide('change-payment-info-modal');
    },
    beforeOpen({params}) {
      this.currentSubscriptionInfoProps = params.currentSubscriptionInfoProps;
      this.paymentInfoProps = params.paymentInfoProps;
    },
    updatePayment() {
      const pass = this.$refs.paymentInput.checkIfNotEntered();
      if (!pass) {
        return
      }
      const inputData = this.getPaymentInfo();
      this.activeSync = true
      _API.PAYMENT.updatePaymentMethod(inputData)
          .then(({data}) => {
            if (data.isSuccess) {
              this.$modal.show('common-alert-modal', {
                messageType: 'short',
                message: 'alert.change_completed'
              });
              this.$emit('getMyPurchaseSummaryFromServer');
              this.$modal.hide('change-payment-info-modal');
            } else {
              switch (data.failedCode) {
                case 'PAY2406' : // 신용카드 번호가 잘못되었습니다.
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.credit_num_incorrect'
                  });
                  break;
                case 'PAY2407' : // 신용카드 만료일이 잘못되었습니다.
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.expiration_incorrect'
                  });
                  break;
                case 'PAY2408' : // 신용카드가 만료되었습니다.
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.credit_expired'
                  });
                  break;
                default:
                  /**
                   * MA2000 = 매니져가 아니거나 잘못된 매니져 상태
                   * PAY2000 = 결제서버 알 수 없는 오류
                   * PAY2400 = 유저 ID가 Null 입니다. (서버오류)
                   * PAY2404 = 유저 E-MAIL이 NULL입니다. (서버오류)
                   * 이외 예기치 못한 에러
                   */
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.retry_again'
                  });
                  break;
              }
            }
          })
          .finally(() => {
            this.activeSync = false;
          })
    },
    getPaymentInfo() {
      const paymentInfo = this.$refs.paymentInput.fields;
      const time = new Date().getTime();

      return {
        cardType: this.checkCardNumValidation(paymentInfo[0].items[0].value),
        cardNumber: this.encryptFunc(paymentInfo[0].items[0].value, time),
        expirationDate: this.encryptFunc(paymentInfo[1].items[0].value, time),
        cardCode: this.encryptFunc(paymentInfo[1].items[1].value, time),
        firstName: paymentInfo[2].items[0].value.trim(),
        lastName: paymentInfo[2].items[1].value.trim(),
        email: paymentInfo[3].items[0].value.trim(),
        zipcode: paymentInfo[3].items[1].value,
        address: paymentInfo[4].items[0].value.trim(),
        time: time,
      }
    },
  }
}
</script>
<style lang="scss">

.v--modal-overlay[data-modal="change-payment-info-modal"] {
  .v--modal-box {
    overflow: unset;

    .payment_contents_container {
      background: var(--grey10);
      padding: 24px;
      border-radius: var(--pannel-radius);
    }

    .change_payment_detail {
      .header_container {
        display: none;
      }

      .member_wrap {
        width: 100%;
      }
    }
  }
}
</style>
